module.exports = __webpack_public_path__ + "fonts/_Gotham-Book.1c3e155e.ttf";